import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import {} from 'states/store'

import { RelatedItem } from '@crew/apis/feed/models/getRelatedItemByChatRoomId/response'
import { MyTaskDisplayModeButtonGroup } from 'enums/app'

type SliceState = {
  toRelatedItem: RelatedItem | null
  selectedMyTaskListDisplayMode: string
}

const initialSliceState: SliceState = {
  toRelatedItem: null,
  selectedMyTaskListDisplayMode: MyTaskDisplayModeButtonGroup.List.id,
}

export const homeSlice = createSlice({
  name: 'home',
  initialState: initialSliceState,
  reducers: {
    changeRelatedItem: (state, action: PayloadAction<RelatedItem>) => {
      const relatedItem = action.payload
      state.toRelatedItem = relatedItem
    },

    resetRelatedItem: (state) => {
      state.toRelatedItem = null
    },

    setSelectedMyTaskListDisplayMode: (
      state,
      action: PayloadAction<string>
    ) => {
      state.selectedMyTaskListDisplayMode = action.payload
    },
  },
})

const {
  changeRelatedItem,
  resetRelatedItem,
  setSelectedMyTaskListDisplayMode,
} = homeSlice.actions

export { changeRelatedItem, resetRelatedItem, setSelectedMyTaskListDisplayMode }
